module.exports = __webpack_public_path__ + "static/media/cv.97839333.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cv.svg
// module id = 93
// module chunks = 0